import { put, takeLatest } from 'redux-saga/effects'
import { CLOSE_SIDE_PANEL, OPEN_SIDE_PANEL, TOGGLE_SIDE_PANEL } from 'modules/SidePanel/store/types'

function* toggleSidePanel({ payload: { id } = {} }) {
  if (id == null) {
    yield put({ type: CLOSE_SIDE_PANEL })
    return
  }

  yield put({ type: OPEN_SIDE_PANEL, payload: { id } })
}

export default function* Sagas() {
  yield takeLatest(TOGGLE_SIDE_PANEL, toggleSidePanel)
}
